// mvp-returns Phase H17 — Failed Operation status pill (dot + dark text, no coloured borders)

import { useTranslation } from "react-i18next";
import type { FailedOpStatus } from "../../apis/failed-ops";
import { DotPill } from "../delivery/atoms";
import type { Tone } from "../delivery/atoms";

const STATUS_TONE: Record<FailedOpStatus, Tone> = {
  PENDING                     : "grey",
  RETRYING                    : "blue",
  MANUAL_INTERVENTION_REQUIRED: "amber",
  RESOLVED                    : "green",
  GIVEN_UP                    : "grey",
};

interface Props {
  status: FailedOpStatus;
}

export function FailedOpsStatusBadge({ status }: Props) {
  const { t } = useTranslation("returns");
  return (
    <DotPill tone={STATUS_TONE[status] ?? "grey"}>
      {t(`failedOps.status.${status}`, { defaultValue: "-" })}
    </DotPill>
  );
}
